<template>
    <div class="surveyM">
        <div class="swiper">
            <div class="prev">
                <img class="prevPic" src="../assets/img/arrow-l@2x.png" alt="" />
            </div>
            <div class="next">
                <img class="prevPic" src="../assets/img/arrow-right@2x.png" alt="" />
            </div>
            <div class="legend">
                <span class="yellow"><span class="miniDot yellowDot"></span> 计量波动(%)</span><span><span
                        class="miniDot"></span> 实际重量(kg)</span>
            </div>
            <el-carousel
                ref="mixCarousel"
                :key="carouselRenderKey"
                height="100%"
                indicator-position="none"
                :autoplay="false"
                :initial-index="activeMixIndex"
                @change="changeSwiper"
            >
                <el-carousel-item
                    v-for="(item, index) in swiperList"
                    :key="item.rowKey || (item.id + '-' + index)"
                >
                    <div class="currentMaterial">
                        <span class="mix-name">{{ item.mixplantName ? item.mixplantName : "-/-" }}</span>
                        <div class="mix-meta">
                            <!-- 已停机：红框一体样式 -->
                            <div
                                v-if="getPlantStatusKey(item) === 'pending'"
                                class="mix-halt-badge"
                            >
                                <svg
                                    class="mix-halt-icon"
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M8 1.5v6"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.6"
                                        stroke-linecap="round"
                                    />
                                    <path
                                        d="M4.2 3.8a5.5 5.5 0 1 0 7.6 0"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.6"
                                        stroke-linecap="round"
                                    />
                                </svg>
                                <span class="mix-halt-status">已停机</span>
                                <template v-if="item.dischargingTime">
                                    <span class="mix-halt-label">最后出料:</span>
                                    <span class="mix-halt-time">{{ formatDischargeTime(item.dischargingTime) }}</span>
                                </template>
                            </div>
                            <!-- 生产中：绿框一体样式 -->
                            <div
                                v-else-if="getPlantStatusKey(item) === 'active'"
                                class="mix-producing-badge"
                            >
                                <svg
                                    class="mix-producing-icon"
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                >
                                    <circle
                                        cx="8"
                                        cy="8"
                                        r="6.2"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        d="M6.2 5.2v5.6M9.8 5.2v5.6"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.6"
                                        stroke-linecap="round"
                                    />
                                </svg>
                                <span class="mix-producing-status">生产中</span>
                                <template v-if="item.dischargingTime">
                                    <span class="mix-producing-label">出料时间:</span>
                                    <span class="mix-producing-time">{{ formatDischargeTime(item.dischargingTime) }}</span>
                                </template>
                            </div>
                            <!-- 今日未生产：不展示状态文案 -->
                        </div>
                    </div>
                    <div class="swiperCon">
                        <!-- <div class="write"></div> -->
                        <div class="aggregate" v-if="type == 'lq'">
                            <el-row>
                                <el-col :span="2" v-for="items in (item.powder || [])" :key="items.storeInfo + 'a'">
                                    <div class="aggregateY">{{ items.offset }}</div>
                                    <div class="aggregateB">{{ items.weight }}</div>
                                    <div class="aggregateN">{{ items.storeInfo }}</div>
                                </el-col>
                                <el-col :span="2" v-if="2 - (item.powder || []).length > 0"
                                    v-for="(itemes, i) in (2 - (item.powder || []).length)" :key="i + 'a'">
                                    <div class="aggregateY">/</div>
                                    <div class="aggregateB">/</div>
                                    <div class="aggregateN">
                                        矿粉{{ (item.powder || []).length + 1 + i }}
                                    </div>
                                </el-col>
                                <el-col :span="1" class="mar">
                                    <div class="aggregateW">""</div>
                                </el-col>
                                <el-col :span="2" class="mar" v-for="itemes in item.aggregates"
                                    :key="itemes.storeInfo + 'b'">
                                    <div class="aggregateY">{{ itemes.offset }}</div>
                                    <div class="aggregateB">{{ itemes.weight }}</div>
                                    <div class="aggregateN">{{ itemes.storeInfo }}</div>
                                </el-col>
                                <el-col :span="2" class="mar" v-if="6 - (item.aggregates || []).length > 0"
                                    v-for="(itemes, i) in (6 - (item.aggregates || []).length)" :key="i + 'b'">
                                    <div class="aggregateY">/</div>
                                    <div class="aggregateB">/</div>
                                    <div class="aggregateN">
                                     #料
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <div class="aggregateW">""</div>
                                </el-col>
                                <el-col :span="2" class="ali" v-for="itemas in item.asphalt"
                                    :key="itemas.storeInfo + 'c'">
                                    <div class="aggregateY">{{ itemas.offset }}</div>
                                    <div class="aggregateB">{{ itemas.weight }}</div>
                                    <div class="aggregateN">{{ itemas.storeInfo }}</div>
                                </el-col>
                                <el-col :span="2" class="ali" v-if="1 - (item.asphalt || []).length > 0"
                                    v-for="(itemes, i) in 1 - (item.asphalt || []).length" :key="i + 'c'">
                                    <div class="aggregateY">/</div>
                                    <div class="aggregateB">/</div>
                                    <div class="aggregateN">沥青</div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="aggregateSW" v-else>
                            <el-row>
                                <el-col :span="2" v-for="items in (item.powder || [])" :key="items.storeInfo + 'd'" class="mar">
                                    <div class="aggregateY">{{ items.offset > 0 ? items.offset : '' }}</div>
                                    <div class="aggregateB">{{ items.weight > 0 ? items.weight : '' }}</div>
                                    <div class="aggregateN">{{ items.storeInfo }}</div>
                                </el-col>
                                <el-col :span="2" v-if="6 - (item.powder || []).length > 0"
                                    v-for="(itemes, i) in (6 - (item.powder || []).length)" :key="i + 'd'" class="mar">
                                    <div class="aggregateY"></div>
                                    <div class="aggregateB"></div>
                                    <div class="aggregateN">
                                        {{ (item.powder || []).length + 1 + i }}#料
                                    </div>
                                </el-col>
                                <el-col :span="2" class="mare">
                                    <div class="aggregateY">{{ item.aggregates[0] && item.aggregates[0].offset >
                                        0?item.aggregates[0].offset:'' }}</div>
                                    <div class="aggregateB">{{ item.aggregates[0] && item.aggregates[0].weight
                                        >0?item.aggregates[0].weight:'' }}</div>
                                    <div class="aggregateN">水泥</div>
                                </el-col>
                                <el-col :span="2" class="mart">
                                    <div class="aggregateY">{{ item.asphalt[0] && item.asphalt[0].offset > 0
                                        ?item.asphalt[0].offset:'' }}</div>
                                    <div class="aggregateB">{{ item.asphalt[0] && item.asphalt[0].weight >
                                        0?item.asphalt[0].weight:'' }}</div>
                                    <div class="aggregateN">水</div>
                                </el-col>
                            </el-row>
                        </div>
                        <img class="mixPic" :src="mixPic" alt="" />
                        <div class="currentInfo" v-if="type == 'lq'">
                            <div class="last-output" :title="item.name || ''">
                                最后出料: <span>{{ item.name ? item.name : "-/-" }}</span>
                            </div>
                            <!-- <div>
                                出料温度: <span>{{ item.temp ? item.temp.toFixed(2) + ' °C' : "-/-" }}</span>
                            </div> -->
                             <div>
                                油石比: <span>{{ item.temp ? item.temp.toFixed(2) + '%' : "-/-" }}</span>
                            </div>
                            <div>
                                拌和周期: <span>{{ item.cycle ? item.cycle + ' 秒' : "-/-" }}</span>
                            </div>
                        </div>
                        <div class="currentInfoSW" v-else>
                            <div>出料时间: <span>{{ item.time ? item.time : "-/-" }}</span></div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import {
    getMixplant,
    // getKeyLabellq,
    getRealTimeOutput,
    // getMixplantsw,
    // getKeyLabelsw,
    // getRealTimeOutputsw,
    getCurrentTime,
} from "@/api/api";
export default {
    props: {
        type: "",
    },
    data() {
        return {
            currentDate: "",
            currentTime: "",
            mixplantId: "",
            mixtureId: "",
            activeMixIndex: 0,
            isFirst: true,
            suppressSwiperChange: false,
            // 作业面切换/列表重建期间忽略轮播 @change，并丢弃过期请求
            mixRequestToken: 0,
            suppressReleaseTimer: null,
            // 按接口顺序生成，变化时整表重挂载轮播，避免 el-carousel 索引错乱
            carouselRenderKey: "mix-carousel-empty",
            mixArr: [],
            swiperList: [],
            mixPic: require("../assets/img/asphaltSketch@2x.png"),
        };
    },
    created() {
        this.dataRefreh();
    },
    mounted() {
        const timeMachine = getCurrentTime();
        this.currentDate = timeMachine.split(" ")[0];
        this.currentTime = timeMachine.split(" ")[1];
        if (this.type == "lq") {
            this.mixPic = require("../assets/img/asphaltSketch@2x.png");
        } else {
            this.mixPic = require("../assets/img/WaterStabilitySketch@2x.png");
        }
    },
    beforeDestroy() {
        this.clear();
    },
    methods: {
        // 定时刷新数据函数
        dataRefreh() {
            // 计时器正在进行中，退出函数
            if (this.intervalId != null) {
                return;
            }
            // 计时器为空，操作
            this.intervalId = setInterval(() => {
                this.getmixplant();
            }, 30000);
        },
        // 停止定时器
        clear() {
            clearInterval(this.intervalId); //清除计时器
            this.intervalId = null; //设置为null
            if (this.suppressReleaseTimer) {
                clearTimeout(this.suppressReleaseTimer);
                this.suppressReleaseTimer = null;
            }
        },
        // 作业面切换：锁定轮播、清空旧站，避免后场/轮播沿用上一面选中站
        beginSectionReselect() {
            this.isFirst = true;
            this.suppressSwiperChange = true;
            if (this.suppressReleaseTimer) {
                clearTimeout(this.suppressReleaseTimer);
                this.suppressReleaseTimer = null;
            }
            this.mixplantId = "";
            this.mixtureId = "";
            this.activeMixIndex = 0;
            this.mixArr = [];
            this.swiperList = [];
            this.carouselRenderKey =
                "mix-carousel-empty-" +
                String(this.sectionId || "") +
                "-" +
                Date.now();
            this.$store.commit("updataMixplantWorkAreaId", "");
            this.$store.commit("updataMixplantMixtureId", "");
            this.$store.commit("updataMixplantName", "");
            this.$store.commit("updataMixplantId", "");
        },
        // 用接口顺序生成稳定 key，保证轮播页与返回顺序一致
        buildCarouselRenderKey(list, sectionId) {
            const orderPart = (list || [])
                .map((item, index) => {
                    const id =
                        item && item.mixplant && item.mixplant.id != null
                            ? item.mixplant.id
                            : item && item.id != null
                            ? item.id
                            : index;
                    const mixtureId =
                        item && item.mixture && item.mixture.id != null
                            ? item.mixture.id
                            : item && item.mixtureId != null
                            ? item.mixtureId
                            : "";
                    return (
                        String(index) +
                        ":" +
                        String(id) +
                        ":" +
                        String(mixtureId)
                    );
                })
                .join("|");
            return (
                "mix-carousel-" +
                String(sectionId || "") +
                "-" +
                (orderPart || "empty")
            );
        },
        releaseSuppressSwiperChange(delayMs) {
            if (this.suppressReleaseTimer) {
                clearTimeout(this.suppressReleaseTimer);
                this.suppressReleaseTimer = null;
            }
            const wait = delayMs == null ? 0 : delayMs;
            if (wait <= 0) {
                this.suppressSwiperChange = false;
                return;
            }
            this.suppressReleaseTimer = setTimeout(() => {
                this.suppressReleaseTimer = null;
                this.suppressSwiperChange = false;
            }, wait);
        },
        NumberFix(val) {
            const y = val.getFullYear();
            const m = (val.getMonth() + 1).toString().padStart(2, "0");
            const d = val.getDate().toString().padStart(2, "0");
            const h = val.getHours().toString().padStart(2, "0");
            const mi = val.getMinutes().toString().padStart(2, "0");
            const s = val.getSeconds().toString().padStart(2, "0");
            return `${y}-${m}-${d} ${h}:${mi}:${s}`;
        },
        // working=Y 生产中；todayWorking=Y 今日已停机；否则今日未生产
        getPlantStatusKey(item) {
            const working = item && item.working;
            if (
                working === "Y" ||
                working === "y" ||
                working === true ||
                working === 1 ||
                working === "1"
            ) {
                return "active";
            }
            const todayWorking = item && item.todayWorking;
            if (
                todayWorking === "Y" ||
                todayWorking === "y" ||
                todayWorking === true ||
                todayWorking === 1 ||
                todayWorking === "1"
            ) {
                return "pending";
            }
            return "idle";
        },
        getPlantStatusText(item) {
            const map = {
                active: "生产中",
                pending: "已停机",
                idle: "今日未生产",
            };
            return map[this.getPlantStatusKey(item)] || "";
        },
        // 出料时间仅保留时分秒
        formatDischargeTime(val) {
            if (!val && val !== 0) return "";
            const str = String(val).trim();
            if (!str || str === "0") return "";
            if (str.indexOf(" ") >= 0) {
                return str.split(" ")[1] || str;
            }
            return str;
        },
        findMixByPlantId(list, mixplantId) {
            if (!list || !list.length || mixplantId == null || mixplantId === "") {
                return null;
            }
            const target = String(mixplantId);
            return (
                list.find(
                    (item) =>
                        item &&
                        item.mixplant &&
                        item.mixplant.id != null &&
                        String(item.mixplant.id) === target
                ) || null
            );
        },
        // 本页列表按当前作业面(sectionId)拉取：
        // 只用记录自身 workArea，禁止从 workAreaList 跨面挑选，否则多站切换会串数据
        resolveWorkAreaId(src) {
            if (src) {
                if (src.workAreaId != null && src.workAreaId !== "") {
                    return src.workAreaId;
                }
                if (
                    src.workArea &&
                    src.workArea.id != null &&
                    src.workArea.id !== ""
                ) {
                    return src.workArea.id;
                }
            }
            return this.sectionId;
        },
        buildMixplantName(preferred) {
            if (!preferred || !preferred.mixplant) return "";
            const name = preferred.mixplant.name || "";
            const cname = preferred.mixplant.brand.cname || "";
            const modelNo = preferred.mixplant.brand.modelNo || "";
            // 与切换轮播时一致：名称-编号，供后场/视频解析
            return cname ? name + "-" + cname + modelNo: name;
        },
        commitMixplantStore(preferred, swiperItem) {
            if (preferred && preferred.mixplant) {
                const waId = this.resolveWorkAreaId(preferred);
                const mixtureId = preferred.mixture ? preferred.mixture.id : "";
                this.mixplantId = preferred.mixplant.id;
                this.mixtureId = mixtureId;
                // 先写作业面/配比再写 id，保证后场 watch 时参数齐全
                this.$store.commit("updataMixplantWorkAreaId", waId);
                this.$store.commit("updataMixplantMixtureId", mixtureId);
                this.$store.commit(
                    "updataMixplantName",
                    this.buildMixplantName(preferred)
                );
                this.$store.commit("updataMixplantId", this.mixplantId);
                return;
            }
            if (swiperItem) {
                cosnole.log('swiperItem',ßswiperItem);
                const waId = swiperItem.workAreaId || this.sectionId;
                const mixtureId = swiperItem.mixtureId || "";
                this.mixplantId = swiperItem.id;
                this.mixtureId = mixtureId;
                this.$store.commit("updataMixplantWorkAreaId", waId);
                this.$store.commit("updataMixplantMixtureId", mixtureId);
                this.$store.commit(
                    "updataMixplantName",
                    (swiperItem.mixplantName || "") +
                        (swiperItem.mixplantNo
                            ? "-" + swiperItem.mixplantNo
                            : "")
                );
                this.$store.commit("updataMixplantId", this.mixplantId);
                return;
            }
            this.mixplantId = "";
            this.mixtureId = "";
            this.$store.commit("updataMixplantWorkAreaId", "");
            this.$store.commit("updataMixplantMixtureId", "");
            this.$store.commit("updataMixplantName", "");
            this.$store.commit("updataMixplantId", "");
        },
        applySelectedMixItem(preferred) {
            this.commitMixplantStore(preferred, null);
        },
        // 按 mixplantId 对齐轮播当前页；forceFirst 时固定展示接口第一项
        syncCarouselToMixplant(options = {}) {
            const forceFirst = options.forceFirst === true;
            this.suppressSwiperChange = true;
            this.$nextTick(() => {
                let idx = 0;
                if (!forceFirst && this.mixplantId) {
                    const found = this.swiperList.findIndex(
                        (item) => String(item.id) === String(this.mixplantId)
                    );
                    idx = found < 0 ? 0 : found;
                }
                this.activeMixIndex = idx;
                const cur = this.swiperList[idx];
                // 展示页与 store 强制对齐，避免后场读到另一座站
                if (cur) {
                    const raw = this.findMixByPlantId(this.mixArr, cur.id);
                    if (raw) this.commitMixplantStore(raw, null);
                    else this.commitMixplantStore(null, cur);
                }
                const carousel = this.$refs.mixCarousel;
                if (!carousel || typeof carousel.setActiveItem !== "function") {
                    this.releaseSuppressSwiperChange(0);
                    return;
                }
                carousel.setActiveItem(idx);
                this.$nextTick(() => {
                    this.releaseSuppressSwiperChange(120);
                });
            });
        },
        // 重建列表时保留各站已加载的实时字段，避免定时刷新后短暂/持续空白
        buildSwiperItemFromMix(item, prev, index) {
            const id = item.mixplant.id;
            const mixtureId = item.mixture ? item.mixture.id : "";
            return {
                id: id,
                // 前缀带接口序号，保证 v-for 顺序与返回顺序一致
                rowKey:
                    String(index) +
                    "-" +
                    String(id) +
                    "-" +
                    String(mixtureId || ""),
                mixplantName: item.mixplant.name,
                mixplantNo: item.mixplant.no,
                mixtureId: mixtureId,
                workAreaId: this.resolveWorkAreaId(item),
                name: item.mixture
                    ? item.mixture.type
                        ? item.mixture.type.typeName
                        : ""
                    : "",
                powder: prev && prev.powder ? prev.powder : [],
                aggregates: prev && prev.aggregates ? prev.aggregates : [],
                asphalt: prev && prev.asphalt ? prev.asphalt : [],
                time: prev && prev.time !== undefined && prev.time !== "" ? prev.time : "",
                temp: prev && prev.temp !== undefined && prev.temp !== "" ? prev.temp : "",
                cycle: prev && prev.cycle !== undefined && prev.cycle !== "" ? prev.cycle : "",
                working: item.working || "",
                todayWorking: item.todayWorking || "",
                dischargingTime: (prev && prev.dischargingTime) || "",
            };
        },
        clearRealtimeFields(item) {
            item.time = 0;
            item.dischargingTime = "";
            item.temp = this.type == "lq" ? 0 : "";
            item.cycle = this.type == "lq" ? 0 : "";
            item.powder = [];
            item.aggregates = [];
            item.asphalt = [];
        },
        applyRealtimeFields(item, data) {
            if (!item || !data) return;
            if (this.type == "lq") {
                item.time = data.first ? data.first.split(" ")[1] : 0;
                item.dischargingTime = data.first || "";
                item.temp = data.oilAndStoneRatio;
                item.cycle = data.mixperiod;
                item.powder =
                    (data.second &&
                        data.second.filter(
                            (row) => row.storeInfo && row.storeInfo.indexOf("粉") >= 0
                        )) ||
                    [];
                item.aggregates =
                    (data.second &&
                        data.second.filter(
                            (row) => row.storeInfo && row.storeInfo.indexOf("料") >= 0
                        )) ||
                    [];
                item.asphalt =
                    (data.second &&
                        data.second.filter(
                            (row) => row.storeInfo && row.storeInfo.indexOf("沥") >= 0
                        )) ||
                    [];
                return;
            }
            if (data.second) {
                data.second.forEach((row) => {
                    if (row.storeInfo && row.storeInfo.indexOf("添") >= 0) {
                        row.storeInfo =
                            row.storeInfo.charAt(0) +
                            row.storeInfo.charAt(row.storeInfo.length - 1);
                    }
                });
            }
            item.time = data.first ? data.first.split(" ")[1] : 0;
            item.dischargingTime = data.first || "";
            item.temp = data.temp;
            item.cycle = data.mixperiod;
            item.powder =
                (data.three &&
                    data.three.filter(
                        (row) =>
                            row.storeInfo &&
                            (row.storeInfo.indexOf("料") >= 0 ||
                                row.storeInfo.indexOf("添") >= 0)
                    )) ||
                [];
            item.aggregates =
                (data.three &&
                    data.three.filter(
                        (row) =>
                            row.storeInfo && row.storeInfo.indexOf("水泥") >= 0
                    )) ||
                [];
            item.asphalt =
                (data.three &&
                    data.three.filter(
                        (row) =>
                            row.storeInfo &&
                            row.storeInfo.indexOf("水") >= 0 &&
                            row.storeInfo.indexOf("水泥") == -1
                    )) ||
                [];
        },
        // 获取拌合楼
        // options.forceReselect：作业面切换强制重选接口返回的第一项，不受 isFirst 竞态影响
        async getmixplant(options = {}) {
            const forceReselect =
                options.forceReselect === true || this.isFirst === true;
            const requestSectionId = this.sectionId;
            const requestToken = ++this.mixRequestToken;
            if (forceReselect) {
                this.suppressSwiperChange = true;
            }
            if (!requestSectionId) return;

            let req = {
                // id: 262,
                id: requestSectionId,
                timeRange: -30,
            };
            const mpDataLQ = await getMixplant(this.type, req);
            // 快速切作业面时丢弃过期响应
            if (
                requestToken !== this.mixRequestToken ||
                String(requestSectionId) !== String(this.sectionId)
            ) {
                return;
            }
            // 保持接口返回顺序，不做前端重排
            let mixList = Array.isArray(mpDataLQ.data)
                ? mpDataLQ.data.slice()
                : [];
            // 过滤无效项，避免空槽打乱轮播索引
            mixList = mixList.filter(
                (item) => item && item.mixplant && item.mixplant.id != null
            );

            if (forceReselect) {
                this.activeMixIndex = 0;
                const preferred = mixList[0] || null;
                if (preferred && preferred.mixplant) {
                    this.applySelectedMixItem(preferred);
                } else {
                    this.applySelectedMixItem(null);
                }
                this.isFirst = false;
            } else if (mixList.length) {
                // 定时刷新：尽量保留当前选中站
                let current = this.findMixByPlantId(mixList, this.mixplantId);
                if (!current) {
                    current = mixList[0] || null;
                    this.activeMixIndex = 0;
                } else {
                    const keepIdx = mixList.findIndex(
                        (item) =>
                            item &&
                            item.mixplant &&
                            String(item.mixplant.id) === String(current.mixplant.id)
                    );
                    this.activeMixIndex = keepIdx < 0 ? 0 : keepIdx;
                }
                this.applySelectedMixItem(current);
            } else {
                this.activeMixIndex = 0;
                this.applySelectedMixItem(null);
            }

            if (
                requestToken !== this.mixRequestToken ||
                String(requestSectionId) !== String(this.sectionId)
            ) {
                return;
            }

            this.mixArr = mixList;
            await this.getRealTimeOutputs({
                rebuild: true,
                forceFirst: forceReselect,
                requestToken: requestToken,
                requestSectionId: requestSectionId,
            });
        },
        // 获取拌合楼拌和原料（仅写入当前选中站）
        async getRealTimeOutputs({
            rebuild = true,
            forceFirst = false,
            requestToken = null,
            requestSectionId = null,
        } = {}) {
            const isStale = () => {
                if (
                    requestToken != null &&
                    requestToken !== this.mixRequestToken
                ) {
                    return true;
                }
                if (
                    requestSectionId != null &&
                    String(requestSectionId) !== String(this.sectionId)
                ) {
                    return true;
                }
                return false;
            };
            if (isStale()) return;

            const requestPlantId = this.mixplantId;
            const currentRaw = this.findMixByPlantId(this.mixArr, requestPlantId);
            if (currentRaw) {
                this.mixtureId = currentRaw.mixture ? currentRaw.mixture.id : "";
            }
            const workAreaId = this.resolveWorkAreaId(
                currentRaw ||
                    this.swiperList.find(
                        (item) => String(item.id) === String(requestPlantId)
                    )
            );
            const requestMixtureId = this.mixtureId;

            if (rebuild) {
                // 先屏蔽 @change，防止列表重建把选中站打回第 0 项
                this.suppressSwiperChange = true;
                const prevMap = {};
                (this.swiperList || []).forEach((row) => {
                    if (row && row.id != null) prevMap[String(row.id)] = row;
                });
                this.swiperList = this.mixArr.map((item, index) =>
                    this.buildSwiperItemFromMix(
                        item,
                        prevMap[String(item.mixplant.id)],
                        index
                    )
                );
                // 列表就绪后再重挂载轮播，确保页序=接口顺序
                this.carouselRenderKey = this.buildCarouselRenderKey(
                    this.mixArr,
                    requestSectionId != null ? requestSectionId : this.sectionId
                );
            }

            if (isStale()) return;

            const currentItem = this.swiperList.find(
                (item) => String(item.id) === String(requestPlantId)
            );

            if (!requestPlantId || !requestMixtureId) {
                if (currentItem) this.clearRealtimeFields(currentItem);
                if (rebuild) this.syncCarouselToMixplant({ forceFirst: forceFirst });
                else this.releaseSuppressSwiperChange(0);
                return;
            }

            let timestamp = new Date().getTime();
            timestamp = timestamp + (1 * 60 * 60 * 1000) / 2;
            var dateAfter = new Date(timestamp);
            var dateBefore = new Date();
            let endDateTime = this.NumberFix(dateAfter);
            let startDateTime = this.NumberFix(dateBefore);
            let req = {
                endDateTime: endDateTime,
                mixplantId: requestPlantId,
                mixtureId: requestMixtureId,
                sectionId: this.seIds,
                startDateTime: startDateTime,
                workAreaId: workAreaId,
            };
            const rtoDataLQ = await getRealTimeOutput(this.type, req);

            if (isStale()) return;
            // 请求返回时若用户已切到别的站，丢弃过期结果
            if (String(this.mixplantId) !== String(requestPlantId)) {
                if (rebuild) this.syncCarouselToMixplant({ forceFirst: forceFirst });
                return;
            }

            const latestItem = this.swiperList.find(
                (item) => String(item.id) === String(requestPlantId)
            );
            if (latestItem && rtoDataLQ && rtoDataLQ.data) {
                this.applyRealtimeFields(latestItem, rtoDataLQ.data);
            } else if (latestItem) {
                this.clearRealtimeFields(latestItem);
            }
            if (rebuild) this.syncCarouselToMixplant({ forceFirst: forceFirst });
        },
        // swiper change：以轮播索引为准同步 store，保证多站时左右数据一致
        changeSwiper(i) {
            if (this.suppressSwiperChange) return;
            const idx = Number(i);
            const cur = this.swiperList[idx];
            if (!cur) return;
            this.activeMixIndex = idx;
            // 与当前站相同则不重复请求（重建列表时的伪 change）
            if (String(cur.id) === String(this.mixplantId)) return;
            const raw = this.findMixByPlantId(this.mixArr, cur.id);
            if (raw) {
                this.commitMixplantStore(raw, null);
            } else {
                this.commitMixplantStore(null, cur);
            }
            // 切换站时不重建列表，避免轮播闪回第 0 项
            this.getRealTimeOutputs({ rebuild: false });
        },

    },
    computed: mapState(["engineerId", "sectionId", "workAreaId", "seIds"]),
    watch: {
        engineerId(curVal, oldVal) {
            if (!curVal || curVal === oldVal) return;
            this.beginSectionReselect();
        },
        sectionId(curVal, oldVal) {
            if (!curVal || curVal === oldVal) return;
            this.beginSectionReselect();
            this.$nextTick(() => {
                if (String(curVal) !== String(this.sectionId)) return;
                this.getmixplant({ forceReselect: true });
            });
        },
        workAreaId(curVal, oldVal) {},
    },
};
</script>
<style lang="less" scoped>
.surveyM {
    height: 100%;
    width: 100%;
    position: absolute;

    .swiper {
        float: left;
        width: 750px;
        height: 100%;
        background-image: url(../assets/img/indication-frame@2x.png);
        background-size: 100% 100%;

        /deep/ .el-carousel__arrow--left {
            color: rgba(255, 255, 255, 0);
            background: rgba(255, 255, 255, 0);
        }

        /deep/ .el-carousel__arrow--right {
            color: rgba(255, 255, 255, 0);
            background: rgba(255, 255, 255, 0);
        }

        .el-carousel {
            height: 100%;
        }

        .el-carousel__item h3 {
            color: #475669;
            font-size: 18px;
            opacity: 0.75;
            line-height: 300px;
            margin: 0;
        }

        .swiperCon {
            width: 80%;
            height: 100%;
            margin: 0 auto;

            .write {
                width: 100%;
                height: 10%;
            }

            .mar {
                margin-left: 6px !important;
            }

            .ali {
                margin-left: 26px !important;
            }

            .aggregate {
                width: 100%;
                height: 30%;

                .el-row {
                    .el-col-1 {
                        width: 5%;
                        margin-left: 4px;
                    }

                    .el-col-2 {
                        width: 8%;
                        margin-left: 2px;
                        font-size: 12px !important;
                    }

                    .el-col-2,
                    .el-col-4 {
                        height: 100%;
                        line-height: 24px;
                        text-align: center;

                        .aggregateY {
                            margin-top: 26px;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                             color: #fff721;
                            height: 18px;
                        }

                        .aggregateB {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #44f8ff;
                            height: 18px;
                        }

                        .aggregateN {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #ffffff;
                        }

                        .aggregateW {
                            color: rgba(255, 255, 255, 0);
                        }
                    }
                }
            }

            .aggregateSW {
                width: 100%;
                height: 30%;

                .mar {
                    margin-left: 2px !important;
                }

                .mare {
                    margin-left: 22px !important;
                }

                .mart {
                    margin-left: 8px !important;
                }

                .el-row {
                    margin-left: 10px;

                    .el-col-1 {
                        width: 5%;
                        margin-left: 4px;
                    }

                    .el-col-2 {
                        width: 9%;
                        // margin-left: 2px;
                    }

                    .el-col-2,
                    .el-col-4 {
                        height: 100%;
                        line-height: 24px;
                        text-align: center;

                        .aggregateY {
                            margin-top: 26px;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #fff721;
                            height: 18px;
                        }

                        .aggregateB {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #44f8ff;
                            height: 18px;
                        }

                        .aggregateN {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #ffffff;
                        }

                        .aggregateW {
                            color: rgba(255, 255, 255, 0);
                        }
                    }
                }
            }

            .mixPic {
                width: 98%;
                height: 58%;
                margin-left: 2%;
            }

            .currentInfo {
                position: absolute;
                bottom: 5px;
                right: 5px;
                text-align: left;
                padding-left: 10px;
                padding-top: 8px;
                line-height: 22px;
                background-image: url(../assets/img/asphalt-messagebox@2x.png);
                background-size: 100% 100%;
                width: 155px;
                height: 73px;

                div {
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    color: #ffffff;

                    span {
                        font-size: 12px;
                        font-family: Microsoft YaHei;
                        color: #fff721;
                    }

                    &.last-output {
                        display: flex;
                        overflow: hidden;
                        white-space: nowrap;

                        span {
                            flex: 1;
                            min-width: 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }

            .currentInfoSW {
                position: absolute;
                top: 10px;
                right: 15px;
                text-align: center;
                line-height: 30px;
                background-image: url(../assets/img/time-messagebox@2x.png);
                background-size: 100% 100%;
                width: 158px;
                height: 30px;

                div {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    color: #ffffff;

                    span {
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        color: #fff721;
                    }
                }
            }
        }

        .prev {
            position: absolute;
            left: 0;
            width: 10%;
            height: 100%;
            display: flex;
            align-items: center;
        }

        .prevPic {
            width: 15px;
            height: 48px;
            margin: 0 auto;
        }

        .next {
            position: absolute;
            right: 0;
            width: 10%;
            height: 100%;
            display: flex;
            align-items: center;
        }

        .legend {
            position: absolute;
            top: 15px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #44f8ff;

            .miniDot {
                display: inline-block;
                width: 8px;
                height: 8px;
                background: #44f8ff;
                border-radius: 50%;
            }

            .yellowDot {
                margin-left: 20px;
                background: #fff721;
            }

            .yellow {
                color: #fff721;
                margin: 0 20px;
            }
        }

        .currentMaterial {
            position: relative;
            text-align: center;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 34px;

            .mix-name {
                display: inline-block;
                max-width: 200px;
                line-height: 16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .mix-meta {
                position: absolute;
                right: 10px;
                top: 66%;
                transform: translateY(-50%);
                display: flex;
                align-items: center;
                gap: 10px;
                max-width: 55%;
            }

            .mix-halt-badge {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                max-width: 100%;
                min-height: 28px;
                padding: 5px 12px;
                box-sizing: border-box;
                background: rgba(0, 0, 0, 0.55);
                border: 1px solid #ff4d4f;
                border-radius: 4px;
                line-height: 1.2;
                white-space: nowrap;
            }

            .mix-halt-icon {
                flex-shrink: 0;
                width: 18px;
                height: 18px;
                color: #ff4d4f;
            }

            .mix-halt-status {
                flex-shrink: 0;
                font-size: 15px;
                font-weight: 500;
                color: #ff4d4f;
            }

            .mix-halt-label {
                flex-shrink: 0;
                margin-left: 2px;
                font-size: 15px;
                color: #ffffff;
            }

            .mix-halt-time {
                flex-shrink: 0;
                font-size: 15px;
                font-weight: 500;
                color: #fff721;
            }

            .mix-producing-badge {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                max-width: 100%;
                min-height: 28px;
                padding: 5px 12px;
                box-sizing: border-box;
                background: rgba(0, 0, 0, 0.55);
                border: 1px solid #39ff14;
                border-radius: 4px;
                line-height: 1.2;
                white-space: nowrap;
            }

            .mix-producing-icon {
                flex-shrink: 0;
                width: 18px;
                height: 18px;
                color: #39ff14;
            }

            .mix-producing-status {
                flex-shrink: 0;
                font-size: 15px;
                font-weight: 500;
                color: #39ff14;
            }

            .mix-producing-label {
                flex-shrink: 0;
                margin-left: 2px;
                font-size: 15px;
                color: #ffffff;
            }

            .mix-producing-time {
                flex-shrink: 0;
                font-size: 15px;
                font-weight: 500;
                color: #fff721;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/survey.vue